import { render, staticRenderFns } from "./CompanyIaCorrectiveActionReport.vue?vue&type=template&id=4d40693e&scoped=true&"
import script from "./CompanyIaCorrectiveActionReport.vue?vue&type=script&lang=js&"
export * from "./CompanyIaCorrectiveActionReport.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIaCorrectiveActionReport.vue?vue&type=style&index=0&id=4d40693e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40693e",
  null
  
)

export default component.exports